import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 70%;
`;

export const StyledTitle = styled.h1`
  ${pickThemeFontStyles('28', '32', 'BOLD')};
  color: ${pickThemeColor('BLACK_PRIMARY')};
  margin: 0;
`;
